/* Engraving location profile, derived from the selected package variant.
   Package = how many marks and where; price is per physical tool, not per mark. */
(() => {
  'use strict';
  if (window.stEngravingLocations) return;
  const q = (root, selector) => root.querySelector(selector);
  function describe(code, p) {
    const deg = '0\u00b0, 120\u00b0 and 240\u00b0';
    switch (code) {
      case 'SINGLE': return 'Single package: 1 mark on the front wheel face only (1 mark total)';
      case 'TRIPLE': return `Triple package: 3 marks evenly spaced at ${deg} around the front wheel face; back face blank (3 marks total)`;
      case 'BOTH': return 'Both-faces package: 1 mark on the front wheel face + 1 mark on the back wheel face (2 marks total)';
      case 'TRIPLE-BOTH': return `Triple both-faces package: 3 marks at ${deg} on the front wheel face + 3 marks at ${deg} on the back wheel face (6 marks total)`;
      case 'FRAME-BOTH': return 'Both faces + frame package: 1 mark on the front wheel face + 1 mark on the back wheel face + 1 mark on one frame side (3 marks total)';
      case 'FRAME': return 'Frame package: 1 mark on one side of the sheave frame only; no wheel marks (1 mark total)';
      default: return p ? `${p.total} marks` : '';
    }
  }
  function sync(root) {
    const P = window.stEngravingPackages;
    if (!P || !q(root, '[data-eng-option]')) return false;
    const changed = P.reconcile(root);
    P.render(root);
    const note = q(root, '[data-eng-locations-note]');
    if (note) {
      const m = P.model(root);
      note.textContent = m.startsWith('feed-')
        ? 'Feeding sheaves: one frame side only. No wheel engraving. Final frame dimensions are confirmed before engraving.'
        : m && P.selected(root)?.code === 'FRAME' ? 'Frame only: one frame side, no wheel marks. Artwork is fitted to the frame; final dimensions are confirmed before engraving.'
        : m ? 'Price is per tool, not per mark. Every mark uses the same approved text or artwork.' : '';
    }
    return changed;
  }
  function profile(root) {
    const P = window.stEngravingPackages;
    const size = P ? P.model(root) : '';
    const sel = P?.selected(root);
    if (!sel) return {size, package: '', sides: 0, wheelSides: 0, frameSides: 0, marksPerFace: 0, totalMarks: 0, label: '', valid: false};
    return {size, package: sel.code, packageName: sel.name, kind: sel.kind, sku: sel.sku,
      sides: sel.wheel + sel.frame, wheelSides: sel.wheel, frameSides: sel.frame,
      marksPerFace: sel.wheel ? sel.per : 0, totalMarks: sel.total,
      wheelAngles: sel.wheel ? P.ANGLES.slice(0, sel.per) : [],
      label: describe(sel.code, sel), valid: !!size && P.allowed(size).includes(sel.code)};
  }
  window.stEngravingLocations = {sync, profile, describe};
})();
